export const GET_RESOURSES__REQUEST = 'ROOT_TYPE__GET_RESOURSES__REQUEST'
export const GET_RESOURSES__SUCCESS = 'ROOT_TYPE__GET_RESOURSES__SUCCESS'
export const GET_RESOURSES__FAILURE = 'ROOT_TYPE__GET_RESOURSES__FAILURE'
